import html from "./PatientEventsViewer.html"
import "./PatientEventsViewer.css"
import moment from 'moment-timezone';

var module = angular.module("ResearchKitApplicationModule");
module.component('patientEventsViewer', {
	template: html,
	bindings: {
		patientId: "=",
		view: "="
	},
	controller: 'patientEventsViewerController',
	controllerAs: 'vm'
});

module.controller("patientEventsViewerController", ["$http", "ceUrl", "$scope",
	function ($http, ceUrl, $scope) {
		var vm = this;
		vm.loading = true;

		function reload(newValue, oldValue) {
			vm.loading = true;
			var baseUrl = 'api/cfhrpatientevents/viewdata/' + vm.view + "?patientID=" + vm.patientId + "&displayOptionKey=" + vm.currentDisplayOption.Key;
			var path = ceUrl.make(baseUrl);
			$http.get(path).then(function (response) {
				vm.data = response.data;
				vm.loading = false;
			});
		}

		function load() {
			var baseUrl = 'api/cfhrpatientevents/viewconfiguration/' + vm.view + "?patientID=" + vm.patientId;
			var path = ceUrl.make(baseUrl);
			$http.get(path).then(function (response) {
				var result = response.data;
				vm.configuration = result;
				vm.displayOptions = result.DisplayOptions;
				vm.data = result.Data;
				vm.currentDisplayOption = vm.configuration.DisplayOptions[0];
				vm.viewDisplayName = result.ViewDisplayName;
				$scope.$watch("vm.currentDisplayOption", function (newValue, oldValue) {
					if (newValue == oldValue) {
						return;
					}
					reload();
				});
				vm.loading = false;
			});
		}

		vm.formatDate = function (dateTimeOffset) {
			var date = moment(new Date(dateTimeOffset.substring(0, 10)));
			return date.format('L');
		}

		vm.startReconciling = function () {
			vm.selfReconciling = true;
			for (var i = 0; i < vm.data.length; i++) {
				for (var j = 0; j < vm.data[i].Events.length; j++) {
					vm.data[i].Events[j].active = vm.data[i].Events[j].Active;
				}
			}
		}

		vm.saveReconciliation = function () {
			vm.savingReconciliation = true;
			var path = ceUrl.make('api/cfhrpatientevents/selfreconcile/' + vm.view + "/" + vm.currentDisplayOption.Key);
			var rows = [];
			for (var i = 0; i < vm.data.length; i++) {
				for (var j = 0; j < vm.data[i].Events.length; j++) {
					var event = vm.data[i].Events[j];
					rows.push({ Value: event.Name, Active: event.active });
				}
			}

			$http.post(path, rows).then(function () {
				vm.selfReconciling = false;
				vm.savingReconciliation = false;
				reload();
			});
		}

		vm.isInactive = function (event) {
			for (var i = 0; i < event.DisplayProperties.length; i++) {
				if (event.DisplayProperties[i].Type == "Status" && !event.Active) {
					return true;
				}
			}
			return false;
		}

		vm.flaggedDisplayProperty = function (event) {
			if (event.DisplayProperties) {
				for (var i = 0; i < event.DisplayProperties.length; i++) {
					if (event.DisplayProperties[i].Type == "Flagged") {
						return event.DisplayProperties[i];
					}
				}
			}
			return null;
		}

		vm.flag = function (event) {
			if (!vm.configuration.IsSelf) {
				return;
			}
			var displayProperty = vm.flaggedDisplayProperty(event);
			if (!displayProperty) {
				return;
			}
			displayProperty.Flagged = true;
			var path = ceUrl.make('api/cfhrpatientevents/flag/' + vm.view + "/" + vm.currentDisplayOption.Key);
			$http.post(path, { Value: event.Name });
		}

		vm.unflag = function (event) {
			if (!vm.configuration.IsSelf) {
				return;
			}
			var displayProperty = vm.flaggedDisplayProperty(event);
			if (!displayProperty) {
				return;
			}
			displayProperty.Flagged = false;
			var path = ceUrl.make('api/cfhrpatientevents/unflag/' + vm.view + "/" + vm.currentDisplayOption.Key);
			$http.post(path, { Value: event.Name });
		}

		vm.startAnnotating = function (property) {
			if (!vm.configuration.IsSelf) {
				return;
			}
			property.editingAnnotation = true;
			property.startAnnotation = property.Annotation;
		}

		vm.cancelAnnotating = function (property) {
			property.editingAnnotation = false;
			property.Annotation = property.startAnnotation;
		}

		vm.saveAnnotation = function (event, property) {
			if (!vm.configuration.IsSelf) {
				return;
			}
			property.editingAnnotation = false;
			var path = ceUrl.make('api/cfhrpatientevents/annotate/' + vm.view + "/" + vm.currentDisplayOption.Key);
			$http.post(path, { Value: event.Name, Annotation: property.Annotation });
		}

		$scope.$watch("vm.currentDisplayOption", function () {
			vm.selfReconciling = false;
		});

		vm.$onInit = function () {
			load();
		}
	}
]);